import { observer } from 'mobx-react-lite';

import { Typography } from '@workspace/ui/components/Typography';

import { useGlobal } from '~/hooks/useGlobal';

import type { BlockCommonProps } from '../shared/interfaces';
import { ViewAllButton } from '../shared/ViewAllButton';
import styles from './CategoriesGrid1S.module.scss';
import { Body } from './components/Body';

const CategoriesGrid1S = ({ category, priority }: BlockCommonProps) => {
  const { subcategory, name } = category;
  const { isMobile } = useGlobal();

  const TitleComponent = isMobile
    ? Typography.Header100Medium
    : Typography.Header400Medium;

  return (
    <div className={styles.root}>
      <div className={styles.head}>
        <TitleComponent as="h3" className={styles.title}>
          {name}
        </TitleComponent>
        <ViewAllButton link="/shop" />
      </div>
      <Body items={subcategory} priority={priority} />
    </div>
  );
};

export default observer(CategoriesGrid1S);
